import Avatar from '@material-ui/core/Avatar';

import { Grade } from '../../../types/Certificate';

const gradeColors = {
    A: '#0A8647',
    B: '#2DA848',
    C: '#95CA53',
    D: '#FFCC00',
    E: '#F78521'
};

/*
 * This component shows the certificate grade of a company.
 */

interface Props {
    grade?: Grade;
    className?: string;
}

const GradeBadge = (props: Props) => {
    const { className, grade } = props;

    return (
        <Avatar className={className} style={{...(grade && {backgroundColor: gradeColors[grade] ?? '#ffffff'})}} >
            {grade ?? '?'}
        </Avatar>
    );
};

export default GradeBadge;
